module.exports = __webpack_public_path__ + "img/title-mobile.c794d6bb.png";